export enum AssetClass {
    Fund = 1,
    Cash = 2,
}
